import {React,useState} from 'react'
import './Somes.css'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
const Iq2 = () => {
    return (
        <div>
                 <NavLink to='/category/Interview question/4'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Interview question/2'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'80px'}}>&lt;- Previous page </Button>
</NavLink>
<td>

<div class="concepts">
<a > Aptitude Concepts</a>
</div>
<div>
<h1 class="h1"style={{float:'left'}}> Aptitude Questions</h1>
<h3 style={{float:'right', margin:'20px'}}> Topics: <b>Partnership</b></h3>
</div>

<br /> <br /> <br /> <br /> <br />

<br />
<p class="pq">1) Sohan started a business with a capital of Rs. 80000.  After 6 months Mohan joined as a partner by investing Rs. 65000. After one year they earned total profit Rs. 20000. What is share of Sohan in the profit?</p>
<ol class="pointsu">
<li className='list'>Rs. 5222.2</li>                                              
<li className='list'>Rs. 14222.2</li>
<li className='list'>Rs. 6222.2</li>                                              
<li className='list'>Rs. 6777.7</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show answer'>
 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p>The Correct answer is (B)</p>
<p><strong>Explanation:</strong></p>
<p>Sohan's capital be C1 = 80000</p>
<p>Mohan's capital be C2 = 65000</p>
<p>Sohan's time be T1 = 12 months</p> 
<p>Mohan's time be T2 = 6 months</p>
<p>Profit earned = 20000</p>
<p><strong>Apply formula:</strong><span><img src="https://static.javatpoint.com/aptitude/images/partnership7_1.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Partnership7"/></span></p>
<p>Therefore, Sohan's share = <span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-q8.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Partnership8"/></span></p>
<p><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-q9.png" alt="Apti Partnership"/></span></p>
<p><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-q10.png" alt="Apti Partnership-q10"/></span></p>
<p><strong>Solution: 2</strong></p>
<p>Ratio of their profits = <span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-q11.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Partnership11"/></span></p>
<p><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-q12.png" alt="Apti Partnership-q12"/></span></p>
<p>Therefore, Profit of Sohan: Profit of Mohan = 32:13</p>
<p>Then, Sohan's share =<img src="https://static.javatpoint.com/aptitude/images/partnership7_2.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Partnership7"/>* 20000= 14222.2</p>
</div> </Collapsible>
<br />
<p class="pq">2) A, B and C are partners. They have invested Rs.35000, Rs. 25000 and 10,000 respectively for the same period. If the total profit is Rs. 18000, find the share of A.</p>
<ol class="pointsu">
<li className='list'>Rs. 9000</li>                                                
<li className='list'>Rs. 9500</li>
<li className='list'>Rs. 8000</li>                                                
<li className='list'>Rs. 8500</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show answer'>
 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>A's capital be C1= 35000</p>
<p>B's capital be C2= 25000</p>
<p>C's capital be C3= 10000</p>
<p>Profit = 18000</p>
<p>T1=T2=T3</p>
<p>Apply formula: <span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-q14.png" style={{margin:'5px 4px -14px 0px'}} alt="Apti Partnership14"/></span></p>
<p><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-q15.png" alt="Apti Partnership15"/></span></p>
<p><strong>Solution 2:</strong></p>
<p>Ratio of their profits;</p>
<p>Profit of A: Profit of B: Profit of C = C1*T1: C2*T2:C3*T3 </p>
<p>Time is same for A, B and C.</p>
<p>So, Profit of A: Profit of B: Profit of C = C1: C2: C3</p>
<p>= 35000:25000:10000</p>
<p>= 7:5:2</p>
<p>A's share = (A's ratio/ sum of all three ratios)* total profit </p>
<p><span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-16.png" style={{margin:'5px 4px -12px 0px'}} alt="Apti Partnership16"/></span></p>
</div> </Collapsible>
<br />
<p class="pq">3) A's and B's shares in a business are in the ratio of 5:3.  If A has invested Rs. 70000 for 12 months, for what period B has invested Rs. 60000?</p>
<ol class="pointsu">
<li className='list'>7 months</li>                                                   
<li className='list'>7.4 months</li>
<li className='list'>8 months</li>                                                   
<li className='list'>8.4 months</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show answer'>
 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p>The Correct answer is (D)</p>
<p><strong>Explanation:</strong></p> 
<p>A's capital be C1 = 70000</p>
<p>B's capital be C2 = 60000</p>
<p>A's time be T1= 12 months</p>
<p>Let B's time be T2 = X months</p>
<p>A's share: B's share = 5:3</p>
<p>Apply formula:  <span><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-q3.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Partnership"/></span></p>
<p><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-q3-1.png" alt="Apti Partnership"/></p>
<p>300000 X = 2520000 </p>
<img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-q3-2.png" alt="Apti Partnership"/><p></p>
</div> </Collapsible>
<br />

<p class="pq">4) Suresh started a business by investing a certain amount of money.  Rakesh joined him after four months by investing Rs. 50000. If after one year Suresh and Rakesh share the profit in the ratio of 10:8, how much capital did Suresh invest?</p>
<ol class="pointsu">
<li className='list'>Rs. 42000</li>                                              
<li className='list'>Rs. 44000</li>
<li className='list'>Rs. 47000</li>                                              
<li className='list'>Rs. 41666.7</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show answer'>
 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p>The Correct answer is (D)</p>
<p><strong>Explanation:</strong></p> 
<p>Let Suresh's capital be C1 = X</p>
<p>Rakesh's capital be C2 = 50000</p>
<p>Suresh's Time be T1 = 12 months</p>
<p>Rakesh's Time be T2 = 8 months</p>
<p>Suresh's profit: Rakesh's profit = 10:8</p> 
<p>Apply formula: <img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-q4.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Partnership18"/></p>
<p><img class="vmiddle" src="https://static.javatpoint.com/aptitude/images/partnership-q4-1.png" style={{margin:'5px 4px -18px 0px'}} alt="Apti Partnership18"/></p><br/>
<p>X = 41666.7 </p> 
</div> </Collapsible>
<br />
<p class="pq">5) A and B enter into a partnership by investing Rs.14000 and Rs. 16000 respectively. After 8 months, C joins them with a capital of Rs.12000. Find the share of C in a total profit of Rs. 57000 after 2 years.</p>
<ol class="pointsu">
<li className='list'>Rs.12000</li>                                    
<li className='list'>Rs.12500</li>
<li className='list'>Rs.13000</li>                                    
<li className='list'>Rs.13500</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show answer'>
 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>A's capital be C1 = 14000</p>
<p>B's capital be C2 = 16000</p>
<p>C's capital be C3 = 12000</p>
<p>A's time be T1 = 24 months</p>
<p>B's time be T2 = 24 months</p>
<p>C's time be T3 = 16 months</p>
<p>Profit: 57000</p>
<p>Apply formula: Profit of A: Profit of B: Profit of C = C1*T1: C2*T2:C3*T3 </p>
<p>= 14000*24: 16000*24:12000*16</p>
<p>= 336000:384000:192000</p>
<p>= 7: 8: 4<br/>
C's share = <img src="https://static.javatpoint.com/aptitude/images/partnership-q5-1.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Partnership"/> * 57000 = 12000 (Option A)</p>
<p><strong>Solution 2:</strong><br/>
Apply formula :  <img src="https://static.javatpoint.com/aptitude/images/partnership-q5-2.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Partnership"/></p>
<p><img src="https://static.javatpoint.com/aptitude/images/partnership-q5-3.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Partnership"/></p>
 </div> </Collapsible>
<br />


<p class="pq">6) Ramesh and Suresh enter into a partnership with capitals in the ratio of 10:12. At the end of 8 months, Ramesh withdraws. If they receive profits in the ratio of 10:18. Find how long Suresh's capital was used.</p>
<ol class="pointsu">
<li className='list'>7 months</li> 
<li className='list'>8 months</li>  
<li className='list'>10 months</li> 
<li className='list'>12 months</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show answer'>
 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Let the capital of Ramesh (C1) =10<br/>
And the capital of Suresh is (C2) = 12</p>
<p>Time period spend by Ramesh (T1) = 8 months<br/>
Let, time period spend by Suresh (T2) = x months</p>
<p>The ratio of their profit (p1:p2) is 10: 18<br/>
Apply formula: (C1 * T1)/ (C2 * T2) = p1/p2<br/>
(10 * 8)/ (12*x) = (10/18)<br/>
(80/12x) = (5/9) <br/>
20/3x = 5/9<br/>
180 = 15x<br/>
     Hence, x=12 months</p>
</div> </Collapsible>
<br />

<p class="pq">7) Raju started a business with Rs. 900. Kamal joined him after few months with an amount of 600. If the profits at the end of the year were divided in the ratio of 2:1, after how many months Kamal joined the business?  </p>
<ol class="pointsu">
<li className='list'>9 months</li> 
<li className='list'>3 months</li> 
<li className='list'>8 months</li>  
<li className='list'>5 months</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show answer'>
 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>The capital of Raju (C1) =900<br/>
And the capital of Kamal is (C2) = 600</p>
<p>Time period spend by Raju (T1) = 12 months<br/>
Let the time period spend by Kamal (T2) = x months</p>

<p>The ratio of their profit (p1:p2) is 2: 1</p>
<p><strong>Apply the formula: </strong><br/>

(C1 * T1)/ (C2 * T2) = p1/p2<br/>

(900 * 12)/ (600*x) = (2/1)<br/>

10800/600 = 2* x<br/>
x= 18/2<br/>
x= 9 months, i.e., Kamal spend 9 months.<br/>
So, Kamal joined after, 12 - 9= 3 months. </p>
</div> </Collapsible>
<br />

<p class="pq">8) Mahesh and Suresh rent a pasture for 12 months. Mahesh puts in 200 cows for 8 months. How many cows can Suresh put in the pasture for the remaining 4 months if he pays 1(1/2) as much as Mahesh? </p>
<ol class="pointsu">
<li className='list'>450 cows</li> 
<li className='list'>600 cows</li> 
<li className='list'>300 cows</li> 
<li className='list'>520 cows</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show answer'>
 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Let Mahesh's cow (C1) = 200 cows, and time spend T1 = 8 months<br/>
Suresh's cow (C2) = y cows, and time spend T2 = 4 months<br/>
Let the profit of Mahesh = x<br/>
Then the profit of Suresh = 1(1/2)*x  </p>

<p><strong>Apply profit ratio formula:</strong></p>
 
<p>(C1 * T1)/ (C2 * T2) = p1/p2<br/>

(200 * 8)/ (y*4) = (x/ (3x/2))<br/>

400/y = 2x/3x<br/> 
400/y = 2/3<br/>
y = (400*3)/2<br/>
y= 600</p>

<p>Hence, Suresh can put 600 cows for the remaining 4 months.</p>
</div> </Collapsible>
<br />

<p class="pq">9) X and Y enter into a partnership for a year. X invests Rs. 6000, and Y invests Rs. 8000. After 4 months, they admit Z, who invests Rs. 9000. If Y withdraws his contribution after 6 months, how would they share a profit of Rs 1000 at the end of the year? </p>
<ol class="pointsu">
<li className='list'>350, 300, 350</li>
<li className='list'>375, 250, 375</li>
<li className='list'>400, 300, 300</li>
<li className='list'>100, 600,300</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show answer'>
 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>X's capital be C1 = 6000<br/>
Y's capital be C2 = 8000<br/>
Z's capital be C3 = 9000<br/>
X's time be T1 = 12 months<br/>
Y's time be T2 = 6 months<br/>
Z's time be T3 = 8 months<br/>
Profit = 1000</p>

<p><strong>The profit will be divided in the ratio:-</strong></p>
<p>(C1 * T1): (C2 * T2): (C3 * T3)<br/>

(6000*12): (8000*6): (9000*8)<br/>
i.e., 72000: 48000: 72000<br/>
Or, 72:48:72<br/>
Divide the whole equation by 24.<br/>
The ratio will be 3: 2: 3<br/>
Sum of the ratios will be 3+2+3= 8</p>
<p><strong>Apply formula: </strong></p>
<p>X's share = (X's ratio/ sum of all three ratios)* total profit <br/>
Hence, X's share is (3/8) * 10000 = 375<br/>
X's and Z's share are equal in ratio, so Z's share =375<br/>
Y's share = 1000 - (A + B)'s share<br/>
                  = 1000 - 750 = 250 </p>

</div> </Collapsible>
<br />

<p class="pq">10) Praveen and Sunny enter into a partnership. Praveen puts in Rs. 50 and Sunny put in Rs. 45. At the end of 4 months Praveen withdraws half of his capital, and at the end of 6 months, Sunny withdraws half of his capital. Ashu Bhati then enters with a capital of Rs. 70. At the end of 12 months, in what ratio will the profit be divided? </p>
<ol class="pointsu">
<li className='list'>65:32:56</li> 
<li className='list'>54:60:66</li> 
<li className='list'>84:82:80</li> 
<li className='list'>80:81:84</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show answer'>
 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Let Praveen's capital is C1 = 50 for period T1= 4 months, and C11= 25 for period T11= 8<br/>
Sunny's capital is C2 = 45 for period T2 = 6 months, and C22 = 45/2 for period T22= 6 months.<br/>
Ashu Bhati's capital is C3 = 70 for period T3 = 6 months.</p>
<p><strong>Now, apply the profit ratio formula: </strong></p>
<p>(C1 * T1): (C2 * T2): (C3 * T3) = p1: p2: p3<br/>

But here we have 2 different values for Praveen and Sunny.<br/>
 
So, (C1 * T1 + C11 * T11): (C2 * T2 + C22 * T22): (C3 * T3) = p1: p2: p3<br/>

Now, (50*4 + 25*8): (45*6 + (45*2)/6): (70*6) = p1: p2: p3<br/>

The ratio of their profit is p1: p2: p3 = 400: 405: 420<br/>
Divide all ratios by 25.<br/>
Hence, the ratio will be 80: 81: 84</p>
</div> </Collapsible>
<br />



<p class="pq">11) The contributions made by Ravi and Suresh are in the ratio of 3:2. If 5% of total profit is donated and Ravi gets 8550 as his share of profit, what is the total profit?</p>
<ol class="pointsu">
<li className='list'>14000</li> 
<li className='list'>14500</li> 
<li className='list'>15000</li> 
<li className='list'>15500</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show answer'>
 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Let the total profit = x<br/>
The ratio of contribution by Ravi and Suresh = 3:2 <br/>
Sum of ratios = 5</p>

<p><strong>Apply formula: </strong></p>
Ravi's share = (Ravi's ratio/ sum of all ratios)* total profit <br/>
Ravi's share = (3/5) * x = 8550<br/>
x= (8550*5)/3<br/>
Total profit: x= 14250<p></p>

<p>ATQ, the Ravi gets 8550 after 5 % donated<br/>
Now, 95% = 14250<br/>
1% = 14250/ 95<br/>
And, 100% = (14250/95) * 100 = 15000</p>
</div> </Collapsible>
<br />

<p class="pq">12) A, B, and C invest 63000, 56000, and 84000 respectively to start a business. After one year, the profit is distributed in the ratio of their investments. If C's share of profit is Rs.54000, find the total profit earned. </p>
<ol class="pointsu">
<li className='list'>135030</li>
<li className='list'>130500</li>
<li className='list'>145000</li>
<li className='list'>None of these</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show answer'>
 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Let the total profit = x<br/>
The ratio of investment = 63000: 56000: 84000<br/>
                                       =63:56:84<br/>
On dividing by 7, we get 9:8:12 <br/>
Now, sum of the ratios = 29</p>

<p><strong>Apply formula:</strong><br/>
 
C's share = (C's ratio/ sum of all three ratios)* total profit<br/>

C's share = (12/29) * x = 54000<br/>

x= (54000*29)/12<br/>
x= 130500</p>

<p>Hence, the total profit = 130500 </p>
</div> </Collapsible>
<br />

<p class="pq">13) Two partners invest Rs.125000 and Rs. 85000 respectively in a business and agree that 60% of the profit should be divided equally between them and the remaining profit is to be treated as interest on capital. One partner gets 300 more than the other. Find the total profit made in the business. </p>
<ol class="pointsu">
<li className='list'>3739.50</li> 
<li className='list'>3749.50</li> 
<li className='list'>2375.60</li> 
<li className='list'>3937.50</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show answer'>
 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>The investment ratio is: 125000: 85000<br/>
= 125:85 <br/>
On dividing both sides by 5, we get 25:17 <br/>

ATQ, 60% is divided equally, and the remaining 40% is shared on the investment ratio basis.<br/>

The difference between 40% of their profit is 300.</p>

<p><strong>Let a number x</strong><br/>

i.e., 25* x *(40/100) - 17*x *(40/100) = 300<br/>

(1000/100)* x - (680/100)*x =300<br/>

10x - (34/5)*x = 300<br/>
50x-34x = 1500<br/>
16x =1500<br/>
x= 93.75</p>

<p>Total profit means sum of ratios = 25x+17x = 42x<br/>
42*93.75 = 3937.50</p>
</div> </Collapsible>
<br />

<p class="pq">14) A, B, and C enter into a partnership. A invests one-fourth of the capital for one-fourth of the time. B invests one-fifth of the capital for half of the time. C contributes the remaining capital for the whole time. How should they divide a profit of Rs 1140?</p>
<ol class="pointsu">
<li className='list'>150, 540, 870</li>
<li className='list'>100, 160, 860</li>
<li className='list'>100, 160, 880</li>
<li className='list'>120, 170, 830</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show answer'>
 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Let capital is 1unit, and time is 1unit<br/>

Apply the formula to calculate the profit ratio <br/>

(C1 * T1): (C2 * T2): (C3 * T3)<br/>

(¼ * ¼): (1/5 *	½): ((1-(1/4 + 1/5))*1)<br/>
i.e., (1/16): (1/10): (1- (5+4)/20)<br/>
1/16: 1/10: 11/20</p>
<p>To calculate the investment ratio, take LCM of the denominators and multiply with each fraction.<br/>
LCM of 16, 10, and 20 is 80<br/>
Now, (80/16): (80/10): ((11*80)/20)</p>
<p>We get the investment ratio: 5:8:44</p>
<p>Total profit is 1140</p>

<p><strong>Apply formula: </strong></p>

<p>A's share = (A's ratio/ sum of all three ratios)* total profit</p>

<p>A's share = (5/57)* 1140 = 100<br/>
B's share = (8/57)*1140= 160<br/>
C's share = 1140 - (100+160) = 880 </p>
</div> </Collapsible>
<br />

<p class="pq">15) Praveen, Sunny, and Ashu Bhati start a business. Twice the capital of Praveen is equal to thrice the capital of Sunny and Sunny's capital is four times Ashu Bhati's capital. Find the Sunny's share if the total profit earned is 297000.  </p>
<ol class="pointsu">
<li className='list'>107000</li> 
<li className='list'>109000</li> 
<li className='list'>108000</li> 
<li className='list'>115000</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show answer'>
 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Let Praveen's capital = A <br/>
And, Sunny's capital = B <br/>
And, Ashu Bhati's capital = C</p>

<p>So, the ratio of their investment = A: B: C</p>

<p>ATQ,<br/>

A*2 = B*3<br/>
i.e., A = 3B/2<br/>
 
B = 4C<br/>
Or, C = B/4</p>

<p>Now put the values in terms of B.<br/>

A: B: C = 3B/2: B: B/4<br/>

A: B: C = 3/2: 1/1: ¼</p>

<p>Take the LCM of the denominators and multiply with every fraction.  
The LCM of 2, 1, and 4 is 4. </p>

<p>Then, A: B: C = (3*4)/2: (1*4)/1: (1*4)/4</p>

<p>The profit ratio is A: B: C = 6: 4: 1</p>

<p>The Total profit is 297000 </p><p>

</p><p><strong>Apply formula: </strong></p>

Sunny's share = (Sunny's ratio/ sum of all three ratios)* total profit<br/>

Sunny's share = (4/11) * 297000 = 108000<p></p>
</div> </Collapsible>
<br />


 
</td>
        </div>
    )
}

export default Iq2
